import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Route Name is required')
    .min(3, 'Route Name must be at least 3 characters'),
  pickupPoint: yup
    .object()
    .nullable()
    .typeError('Pickup Point is required')
    .required('Pickup Point is required'),
  loadingPoint: yup
    .object()
    .nullable()
    .typeError('Loading Point is required')
    .required('Loading Point is required'),
  unloadingPoint: yup
    .object()
    .nullable()
    .typeError('Unloading Point is required')
    .required('Unloading Point is required'),
  clearancePoint: yup
    .object()
    .nullable()
    .typeError('Clearance Point is required')
    .required('Clearance Point is required'),
});
